var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    fill: "#C4F2DD",
    stroke: "#2A3478"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99927 12C6.52251 12 6.13602 11.6135 6.13602 11.1368V7.23223C6.13602 6.75547 6.52251 6.36898 6.99927 6.36898C7.47603 6.36898 7.86252 6.75547 7.86252 7.23223V11.1368C7.86252 11.6135 7.47603 12 6.99927 12ZM6.84151 4.68449C6.37635 4.68449 5.99927 4.30741 5.99927 3.84225C5.99927 3.37709 6.37635 3 6.84151 3H7.15702C7.62218 3 7.99927 3.37709 7.99927 3.84225C7.99927 4.30741 7.62218 4.68449 7.15702 4.68449H6.84151Z",
    fill: "#2A3478"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.b024a3b8eb39461954e42a26d8c7952c.svg";
export { ForwardRef as ReactComponent };